import React from 'react';
import ContactGauger from './ContactGauger';

export default function GaugerCard() {
  return (
    <ContactGauger />
  );
}
